const $inject = ['$q', '$http', 'apiService'];

const userDebtorService = function ($q, $http, apiService) {
  let service = {};
  service.debtor = null;
  service.get = get;
  service.getAny = getAny;
  service.update = update;
  service.bookingRules = bookingRules;
  service.paymentMethod = paymentMethod;
  service.paymentMethods = paymentMethods;
  service.removePaymentMethod = removePaymentMethod;
  service.clear = clear;

  return service;

  function getAny(debtorId) {
    let deferred = $q.defer();

    if (service.debtor) {
      deferred.resolve(service.debtor);
    } else {
      deferred.resolve(get(debtorId));
    }

    return deferred.promise;
  }

  function get(debtorId) {
    let deferred = $q.defer();

    const apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });

    $http
      .get(apiUrl)
      .success((response, status, headers) => {
        service.debtor = _.merge(response, { ETag: headers('ETag') });
        deferred.resolve(service.debtor);
      })
      .error(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function update(debtor) {
    let deferred = $q.defer();
    let debtorId = debtor.Name;

    const apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });

    $http
      .put(apiUrl, _.omit(debtor, 'ETag'), {
        headers: {
          'If-Match': debtor.ETag,
        },
      })
      .success(() => {
        return get(debtorId).then(
          (response) => {
            deferred.resolve(response);
          },
          (error) => {
            deferred.reject(error);
          }
        );
      })
      .error((error) => {
        deferred.reject(error);
      });

    return deferred.promise;
  }

  function bookingRules() {
    return _.merge({}, _.pick(service.debtor, ['CompanyReference', 'Policy']));
  }

  function paymentMethod(id) {
    return _.cloneDeep(
      _.find(service.debtor.DebtorAgencyCreditCards, (paymentMethod) => {
        return paymentMethod.Id === id;
      })
    );
  }

  function paymentMethods() {
    return _.clone(service.debtor.DebtorAgencyCreditCards);
  }

  function removePaymentMethod(debtor, paymentMethod) {
    debtor.DebtorAgencyCreditCards = _.filter(debtor.DebtorAgencyCreditCards, (card) => {
      return card.Id !== paymentMethod.Id;
    });

    return debtor;
  }

  function clear() {
    service.debtor = null;
  }
};

userDebtorService.$inject = $inject;

export default userDebtorService;



// WEBPACK FOOTER //
// ./src/services/userDebtorService.js